import { useState, type FormEvent } from 'react';
import { Button, Field, TextInput } from '../ui';
import { useLogin } from './session';

export default function LoginScreen() {
  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');
  const login = useLogin();

  const submit = (event: FormEvent) => {
    event.preventDefault();
    if (!password) return;
    login.mutate({ username, password }, { onError: () => setPassword('') });
  };

  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <form
        onSubmit={submit}
        className="w-full max-w-sm rounded-xl border border-line bg-surface-1/90 p-6 shadow-2xl backdrop-blur"
      >
        <h1 className="font-display text-2xl text-gold-300">Lobby Manager</h1>
        <p className="mt-1 mb-6 text-sm text-ink-dim">Enter the access password to continue.</p>

        <Field label="Organizer username" hint="Leave blank when using the shared access password">{({ id }) => <TextInput id={id} autoComplete="username" value={username} onChange={e => setUsername(e.target.value)} />}</Field>
        <Field label="Password" error={login.isError ? (login.error as Error).message : undefined}>
          {({ id, describedBy }) => (
            <TextInput
              id={id}
              aria-describedby={describedBy}
              type="password"
              autoFocus
              autoComplete="current-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          )}
        </Field>

        <Button
          type="submit"
          variant="primary"
          className="mt-5 w-full"
          loading={login.isPending}
          disabled={!password}
        >
          Sign in
        </Button>

        <p className="mt-5 text-xs text-ink-faint">
          The API key stays on the server. This password only unlocks this client.
        </p>
      </form>
    </div>
  );
}
